import { BaseEditViewStore} from 'core/stores';
import { FacilityOrderTemplateNewFlowPortalNoteModalForm } from 'application/facility-order-new-flow/forms';
import { FacilityOrderTemplateService } from "application/facility-order/services";
import { action } from "mobx";

class FacilityOrderTemplateNewFlowPortalNoteModalStore extends BaseEditViewStore {
    constructor(rootStore, componentProps) {
        const facilityOrderTemplateService = new FacilityOrderTemplateService(rootStore.application.baasic.apiClient);
        const facilityOrderTemplateId = componentProps.modalParams.data.facilityOrderTemplateId;
        super(rootStore, {
            name: 'facility-order-templat-add-note-modal',
            Form: FacilityOrderTemplateNewFlowPortalNoteModalForm,
            id: facilityOrderTemplateId,
            actions: () => {
                return {
                    get: async(id) =>{
                        const response = await facilityOrderTemplateService.get(id);
                        return response.data;
                    },
                    update: async (resource) => {
                        const response = await facilityOrderTemplateService.updatePortalNote({ ...resource});
                        return response.data;
                    },
                }
            },
            FormClass: FacilityOrderTemplateNewFlowPortalNoteModalForm
        });

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.setNewFlowStatus = this.modalParams.data.setNewFlowStatus;
        this.isBatchUpdate = this.modalParams.data.isBatchUpdate;
        this.refreshPortalNote = this.modalParams.data.refreshPortalNote;
        this.setPatientStatus = this.modalParams.data.setPatientStatus;
        this.showWarningMessage = this.modalParams.data.showWarningMessage;
        this.title = this.modalParams.data.title;
        if(this.title === "Reason for Change / Review"){
            this.form.$("portalNote").set('rules', ['string', 'required']);
        }
    }

    @action.bound
    async updateResource(resource) {
        if (!this.actions.update) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            if(!this.isBatchUpdate){
                await this.actions.update({
                    id: this.id,
                    ...resource
                });
            }

            this.form.setFieldsDisabled(false);
            await this.refreshPortalNote(resource.portalNote);
            await this.setNewFlowStatus();

            if(this.setPatientStatus)
                await this.setPatientStatus();

            this.modalParams.close();
            
            if(resource.portalNote != "")
                await setTimeout(() => this.notifySuccessUpdate(this.name), 10);
        }
        catch(err) {
            this.form.setFieldsDisabled(false);
            return this.onUpdateError(err);
        }
    }

    @action.bound
    notifySuccessUpdate(name) {
        this.rootStore.notificationStore.success('Template Note successfully updated.', name);
    }
}

export default FacilityOrderTemplateNewFlowPortalNoteModalStore;
